import { Button, Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import agent from "../../app/api/agent";
import { BasketItem } from "../../app/models/basket";
import { Order } from "../../app/models/order";
import { useAppSelector } from "../../app/store/configureStore";
import BasketSummary from "../basket/BasketSummary";
import BasketTable from "../basket/BasketTable";

interface Props {
    order: Order;
    setSelectedOrder: (id: number) => void;
}



export default function OrderDetailed({ order, setSelectedOrder }: Props) {
    const { user } = useAppSelector(state => state.account); 
    const subtotal = order.orderItems.reduce((sum, item) => sum + (item.quantity * item.price), 0) ?? 0;
    
        
    return (
        <>
            <Box display='flex' justifyContent='space-between'>
                <Typography sx={{ p: 2 }} gutterBottom variant='h4'>Order# {order.id} - {order.orderStatus}</Typography>
                <Button onClick={() => setSelectedOrder(0)} sx={{ m: 2 }} size='large' variant='contained'>Back to orders</Button>
                {(!user || (user.roles?.includes('Vendor')  )  && (order.orderStatus == "Pending")) && 
                     <Button onClick={() => {agent.Orders.processpayment({order});setSelectedOrder(-1);}} sx={{ m: 2 }} size='large' variant='contained'>Payment Processed</Button>
                }
            </Box>
            <BasketTable items={order.orderItems as BasketItem[]} isBasket={false} />
            <Grid container>
                <Grid item xs={6} >
                    <Card>
                       <CardHeader title="Delivery Details"></CardHeader> 
                       <CardContent>
                            <Typography  color='secondary' variant="h5">
                                {order.shippingAddress_FullName}
                            </Typography>
                            <Typography  variant="h5" color="text.secondary">
                                {order.email} / {order.phoneNumber}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {order.shippingAddress_Address1} , {order.shippingAddress_Address2}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {order.shippingAddress_City} , {order.shippingAddress_State}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {order.shippingAddress_Zip} , {order.shippingAddress_Country}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    {/* <BasketSummary subtotal={subtotal} /> */}
                </Grid>
            </Grid>
        </>
    )
}